import BlockComponentImage from '../../../models/BlockComponentValues/BlockComponentImage';
import BlockComponentText from '../../../models/BlockComponentValues/BlockComponentText';
import BlockSettings, { BlockJustify } from '../../../models/BlockSettings';
import SubBlockMenuData from './SubBlockMenuData';

class BlockMenuListEqualMax3Data {
  title: BlockComponentText;
  titleImage: BlockComponentImage;
  backgroundImage: BlockComponentImage;
  menus: SubBlockMenuData[];
  settings: BlockSettings;
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace BlockMenuListEqualMax3Data {
  export function make(
    title?: string,
    titleImage?: string,
    backgroundImage?: string,
    menus?: SubBlockMenuData[],
    settings?: BlockSettings,
  ): BlockMenuListEqualMax3Data {
    return {
      title: title ? BlockComponentText.make(title) : undefined,
      titleImage: titleImage ? BlockComponentImage.make(titleImage) : undefined,
      backgroundImage: BlockComponentImage.make(backgroundImage),
      menus,
      settings: settings || BlockSettings.getDefault(undefined, BlockJustify.CENTER),
    };
  }

  export function getDefault(title = 'タイトル', titleImage = '', backgroundImage = ''): BlockMenuListEqualMax3Data {
    return make(
      `<p><strong>${title}</strong></p>`,
      titleImage,
      backgroundImage,
      [
        SubBlockMenuData.getDefault(undefined, titleImage),
        SubBlockMenuData.getDefault(undefined, titleImage),
        SubBlockMenuData.getDefault(undefined, titleImage),
        SubBlockMenuData.getDefault(undefined, titleImage),
      ],
    );
  }
}

export default BlockMenuListEqualMax3Data;
